import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { deleteContact, fetchContacts } from '../../../redux/ducks/contacts';
import Contact from '../../../models/Contact';
import ContactView from './ContactView';
import pageWrapper from '../../containers/MainPage';
import Breadcrumbs from '../../common/Breadcrumbs';

class ViewContactPage extends React.Component {
  handleDelete = (id) => {
    this.props.deleteContact(
      id,
      () => {
        this.props.history.push('/contacts');
        this.props.getContacts();
      },
      () => {
        // eslint-disable-next-line no-alert
        alert('Failed to delete contact.');
      }
    );
  };

  render() {
    const { contacts, match } = this.props;

    const contact = contacts.find(c => c.id === parseInt(match.params.id, 10));

    if (!contact) {
      return <h3>Could not find contact</h3>;
    }

    return (
      <React.Fragment>
        <Breadcrumbs
          segments={[{ label: 'Contacts', linkTo: '/contacts' }, { label: contact.name }]}
        />

        <ContactView contact={contact} onDelete={this.handleDelete} />
      </React.Fragment>
    );
  }
}

ViewContactPage.propTypes = {
  contacts: PropTypes.arrayOf(PropTypes.instanceOf(Contact)),
  getContacts: PropTypes.func.isRequired,
  deleteContact: PropTypes.func.isRequired,
  match: PropTypes.shape({
    shape: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

ViewContactPage.defaultProps = {
  contacts: [],
};

function mapStateToProps(state) {
  const {
    contacts: { items },
  } = state;

  return {
    contacts: items,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    deleteContact: (id, onSuccess, onFailure) => {
      dispatch(deleteContact(id, onSuccess, onFailure));
    },
    getContacts: () => {
      dispatch(fetchContacts());
    },
  };
}

export default pageWrapper(
  connect(mapStateToProps, mapDispatchToProps)(ViewContactPage),
  'View Contact'
);



// WEBPACK FOOTER //
// ./src/components/pages/contacts/ViewContactPage.jsx